import { StyleProps, CSS } from "@shared/primitive-components"

export const label = (): CSS => ({
  fontSize: `12px`,
  fontWeight: 500,
})

export const legendContainer = (props: StyleProps): CSS => ({
  width: `100%`,
  fontSize: `12px`,
  fontWeight: 500,
  marginBottom: props.theme.spacing(3),
  "* + *": {
    marginLeft: props.theme.spacing(4),
  },
})

export const item = (props: StyleProps): CSS => ({
  fontSize: `12px`,
  "* + *": {
    marginLeft: props.theme.spacing(2),
  },
})

export const symbol =
  (color: string = `#000`) =>
  (): CSS => ({
    width: `8px`,
    height: `8px`,
    borderRadius: `4px`,
    backgroundColor: color,
  })
